const STREAMTIMELINE_ERROR_BASE = 0x0700;
export const StreamTimelineErrorCodes = Object.freeze({
  /**
   * Indicates that the  streamTimeline setup failed.
   */
  SESSION_INIT_FAILURE: STREAMTIMELINE_ERROR_BASE + 0x01,
});
